export default function MessageIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M13.485 8.09251V11.0925C13.485 11.2875 13.4775 11.475 13.455 11.655C13.2825 13.68 12.09 14.685 9.8925 14.685H9.59251C9.40501 14.685 9.225 14.775 9.1125 14.925L8.21251 16.125C7.81501 16.6575 7.17 16.6575 6.7725 16.125L5.87249 14.925C5.77499 14.7975 5.5575 14.685 5.3925 14.685H5.09251C2.70001 14.685 1.5 14.0925 1.5 11.0925V8.09251C1.5 5.89501 2.51251 4.70251 4.53001 4.53001C4.71001 4.50751 4.89751 4.5 5.09251 4.5H9.8925C12.285 4.5 13.485 5.70001 13.485 8.09251Z'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M16.4863 5.09251V8.09251C16.4863 10.2975 15.4737 11.4825 13.4562 11.655C13.4787 11.475 13.4863 11.2875 13.4863 11.0925V8.09251C13.4863 5.70001 12.2862 4.5 9.89375 4.5H5.09375C4.89875 4.5 4.71125 4.50751 4.53125 4.53001C4.70375 2.51251 5.89625 1.5 8.09375 1.5H12.8937C15.2862 1.5 16.4863 2.70001 16.4863 5.09251Z'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_3'
        d='M10.1216 9.9375H10.1284'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_4'
        d='M7.49662 9.9375H7.50337'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_5'
        d='M4.87162 9.9375H4.87837'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
